/**
 * Generated from hh_ch2_72dpi_p02.fla
 */
export function hh_ch2_72dpi_p02(this: Ihh_ch2_72dpi_p02) {
	const bg = this.bg;
	hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_bg.call(this.bg);
	bg.x = 832;
	bg.y = 768;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const holly = this.holly;
	hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_holly.call(this.holly);
	holly.x = 361.75;
	holly.y = 847.5;
	holly.width = 357.50;
	holly.height = 788.50;
	holly.alpha = 1.00;
	if (holly.onLayout) holly.onLayout();
	const chairsBack = this.chairsBack;
	hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_midgroundchairsback.call(this.chairsBack);
	chairsBack.x = 1028.5;
	chairsBack.y = 550.5;
	chairsBack.width = 530.00;
	chairsBack.height = 129.00;
	chairsBack.alpha = 1.00;
	if (chairsBack.onLayout) chairsBack.onLayout();
	const piper = this.piper;
	hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_midgroundPiper.call(this.piper);
	piper.x = 1172;
	piper.y = 579;
	piper.width = 213.00;
	piper.height = 396.00;
	piper.alpha = 1.00;
	if (piper.onLayout) piper.onLayout();
	const table = this.table;
	hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_midgroundtable.call(this.table);
	table.x = 957.25;
	table.y = 768;
	table.width = 1010.50;
	table.height = 246.00;
	table.alpha = 1.00;
	if (table.onLayout) table.onLayout();
	const oscar = this.oscar;
	hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_foregroundOscar.call(this.oscar);
	oscar.x = 660.25;
	oscar.y = 773;
	oscar.width = 816.50;
	oscar.height = 656.00;
	oscar.alpha = 1.00;
	if (oscar.onLayout) oscar.onLayout();
	const amy = this.amy;
	hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_foregroundAmy.call(this.amy);
	amy.x = 1254.25;
	amy.y = 768;
	amy.width = 614.50;
	amy.height = 618.00;
	amy.alpha = 1.00;
	if (amy.onLayout) amy.onLayout();
	const chairsFront = this.chairsFront;
	hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_foregroundchairsfront.call(this.chairsFront);
	chairsFront.x = 987.25;
	chairsFront.y = 786;
	chairsFront.width = 1100.50;
	chairsFront.height = 327.00;
	chairsFront.alpha = 1.00;
	if (chairsFront.onLayout) chairsFront.onLayout();
	const frameLeft = this.frameLeft;
	hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframeL.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 196.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const frameRight = this.frameRight;
	hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframeR.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384.5;
	frameRight.width = 203.50;
	frameRight.height = 769.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframelinesr.call(this.linesRight);
	linesRight.x = 1664;
	linesRight.y = 257.75;
	linesRight.width = 119.00;
	linesRight.height = 317.50;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const linesLeft = this.linesLeft;
	hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframelinesL.call(this.linesLeft);
	linesLeft.x = 8.5;
	linesLeft.y = 320.25;
	linesLeft.width = 219.50;
	linesLeft.height = 635.50;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_bg(this: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p02_bg", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_holly(this: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p02_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_midgroundchairsback(this: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_midgroundchairsback) {
	if (this.setLayoutTexture) this.setLayoutTexture("chairsback", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_midgroundPiper(this: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_midgroundPiper) {
	if (this.setLayoutTexture) this.setLayoutTexture("Piper", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_midgroundtable(this: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_midgroundtable) {
	if (this.setLayoutTexture) this.setLayoutTexture("table", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_foregroundOscar(this: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_foregroundOscar) {
	if (this.setLayoutTexture) this.setLayoutTexture("Oscar", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_foregroundAmy(this: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_foregroundAmy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Amy", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_foregroundchairsfront(this: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_foregroundchairsfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("chairsfront", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframeL(this: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframeL) {
	if (this.setLayoutTexture) this.setLayoutTexture("L", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframeR(this: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframeR) {
	if (this.setLayoutTexture) this.setLayoutTexture("R", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframelinesr(this: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframelinesr) {
	if (this.setLayoutTexture) this.setLayoutTexture("linesr", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframelinesL(this: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframelinesL) {
	if (this.setLayoutTexture) this.setLayoutTexture("linesL", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ihh_ch2_72dpi_p02Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ihh_ch2_72dpi_p02Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ihh_ch2_72dpi_p02Sprite extends Ihh_ch2_72dpi_p02Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ihh_ch2_72dpi_p02Text extends Ihh_ch2_72dpi_p02Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ihh_ch2_72dpi_p02Polygon extends Array<number> {
}
interface Ihh_ch2_72dpi_p02 {
	readonly bg: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_bg;
	readonly holly: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_holly;
	readonly chairsBack: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_midgroundchairsback;
	readonly piper: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_midgroundPiper;
	readonly table: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_midgroundtable;
	readonly oscar: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_foregroundOscar;
	readonly amy: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_foregroundAmy;
	readonly chairsFront: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_foregroundchairsfront;
	readonly frameLeft: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframeL;
	readonly frameRight: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframeR;
	readonly linesRight: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframelinesr;
	readonly linesLeft: Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframelinesL;
}
interface Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_bg extends Ihh_ch2_72dpi_p02Sprite {
}
interface Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_holly extends Ihh_ch2_72dpi_p02Sprite {
}
interface Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_midgroundchairsback extends Ihh_ch2_72dpi_p02Sprite {
}
interface Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_midgroundPiper extends Ihh_ch2_72dpi_p02Sprite {
}
interface Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_midgroundtable extends Ihh_ch2_72dpi_p02Sprite {
}
interface Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_foregroundOscar extends Ihh_ch2_72dpi_p02Sprite {
}
interface Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAsset1P2chp2_p02_foregroundAmy extends Ihh_ch2_72dpi_p02Sprite {
}
interface Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_foregroundchairsfront extends Ihh_ch2_72dpi_p02Sprite {
}
interface Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframeL extends Ihh_ch2_72dpi_p02Sprite {
}
interface Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframeR extends Ihh_ch2_72dpi_p02Sprite {
}
interface Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframelinesr extends Ihh_ch2_72dpi_p02Sprite {
}
interface Ihh_ch2_72dpi_p02_hh_ch2_72dpi_p02psdAssetP2chp2_p02_wcframelinesL extends Ihh_ch2_72dpi_p02Sprite {
}
